import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import ControlledInput from '@/common/ControllerInput';
import { ContactDetail } from '@/explore/types';
import { ADD_THIS_EMAIL_ANYWAY, phoneLabels } from '@/utils/constants';
import { Checkbox } from '@chakra-ui/react';

interface ContactDetailsEditProps {
  onClickAddContactDetails(): void;
  addcontactDetails: Array<ContactDetail>;
  contactDetails: Array<ContactDetail>;
  onChangeContactDetailField(
    value: string | number | boolean,
    fieldName: string,
    contactDetailIndex: number,
    isNew?: boolean
  ): void;
  onChangeContactDetailPhoneField(
    value: string,
    contactDetailIndex: number,
    phoneIndex: number,
    feildName: string,
    isNew?: boolean
  ): void;
  onClickRemoveContactDetailsNewField(contactDetailIndex: number): void;
  onClickRemoveContactDetail(contactDetailId: number): void;
  onClickAddPhoneNumber(contactDetailIndex: number, isNew?: boolean): void;
  onClickRemovePhoneNumber(
    contactDetailIndex: number,
    phoneIndex: number,
    isNew?: boolean
  ): void;
}

function ContactDetailsEdit({
  addcontactDetails,
  contactDetails,
  onClickAddContactDetails,
  onClickRemoveContactDetail,
  onChangeContactDetailField,
  onChangeContactDetailPhoneField,
  onClickRemoveContactDetailsNewField,
  onClickAddPhoneNumber,
  onClickRemovePhoneNumber
}: ContactDetailsEditProps) {
  const onChangeContactField = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
    fieldName: string,
  ) => {
    onChangeContactDetailField(fieldName === "allowAsValidEmail" ? event.target.checked : event.target.value, fieldName, index, true);
  };
  const onClickSetPrimary = (contactDetailIndex: number, isNew: boolean) => {
    addcontactDetails.map((contactDetail, index) => {
      onChangeContactDetailField(false, 'isPrimary', index, true);
    });
    contactDetails.map((contactDetail, index) => {
      onChangeContactDetailField(false, 'isPrimary', index, false);
    });
    onChangeContactDetailField(true, 'isPrimary', contactDetailIndex, isNew);
  };
  return (
    <div className="contact-details-edit">
      <div className="contact-detail-list">
        {contactDetails.map((contactDetail, index) => (
          <div className="contact-detail-item" key={index}>
            {contactDetail.isPrimary && (
              <div className="contact-detail-item__primary-header">
                Primary Contact Details
              </div>
            )}
            <div className="contact-detail-form">
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <div className="contact-detail-form__icon">
                    <img src="/images/ui/user-outline.svg"></img>
                  </div>
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Contact Name"
                    value={contactDetail.name}
                    onChange={(event) =>
                      onChangeContactDetailField(
                        event.target.value,
                        'name',
                        index
                      )
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__position-title"
                    type="text"
                    placeholder="Enter Contact Tittle"
                    value={contactDetail.title}
                    onChange={(event) =>
                      onChangeContactDetailField(
                        event.target.value,
                        'title',
                        index
                      )
                    }
                  />
                </div>
                {((contactDetail.errors && contactDetail?.errors.name) ||
                  (contactDetail.errors && contactDetail?.errors.title)) && (
                  <div className="contact-detail-form__input-error">
                    <div className="edit-error">
                      {contactDetail.errors && contactDetail?.errors.name && (
                        <>* {contactDetail?.errors.name}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {contactDetail.errors && contactDetail?.errors.title && (
                        <>* {contactDetail?.errors.title}</>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="contact-detail-form__item contact-detail-form__item-phone">
                {contactDetail?.phone && contactDetail?.phone.map((phoneItem, phoneIndex) => {
                  return (
                    <>
                      <div
                        className="contact-detail-form__item-row"
                        key={phoneIndex}
                      >
                        <div className="contact-detail-form__icon">
                          {phoneIndex === 0 && (
                            <img src="/images/ui/phone-outline.svg"></img>
                          )}
                        </div>

                        <ControlledInput
                          className="license-edit__input contact-detail-form__contact-name"
                          type="number"
                          placeholder="Enter Phone Number"
                          value={phoneItem.value}
                          onChange={(event) =>
                            onChangeContactDetailPhoneField(
                              event.target.value,
                              index,
                              phoneIndex,
                              'value'
                            )
                          }
                        />
                        <div className="contact-detail-form__select-dropdown">
                          <AriaSelectDropdown
                            onChangeDropdown={(value) =>
                              onChangeContactDetailPhoneField(
                                value as string,
                                index,
                                phoneIndex,
                                'label'
                              )
                            }
                            selectedOption={phoneItem.label}
                            options={Object.entries(phoneLabels)}
                            className="react-aria-Select react-aria-select-light"
                            variant="light"
                            placeholder="-Label-"
                          />
                        </div>
                        <div
                          className="contact-detail-form__delete-icon"
                          onClick={(event) =>
                            onClickRemovePhoneNumber(index, phoneIndex)
                          }
                        >
                          <img src="/images/ui/delete.svg" alt="" />
                        </div>
                      </div>
                      {contactDetail.errors &&
                        contactDetail?.errors.phone &&
                        contactDetail?.errors.phone[phoneIndex] &&
                        contactDetail?.errors.phone[phoneIndex].valueError && (
                          <div className="edit-error">
                            *{' '}
                            {contactDetail?.errors.phone[phoneIndex].valueError}
                          </div>
                        )}
                      {contactDetail.errors &&
                        contactDetail?.errors.phone &&
                        contactDetail?.errors.phone[phoneIndex] &&
                        contactDetail?.errors.phone[phoneIndex].labelError && (
                          <div className="edit-error">
                            *{' '}
                            {contactDetail?.errors.phone[phoneIndex].labelError}
                          </div>
                        )}
                    </>
                  );
                })}
                <button
                  className="business-add-btn"
                  onClick={(event) => onClickAddPhoneNumber(index)}
                  disabled={contactDetail?.phone ? contactDetail.phone.length >= 3:false}
                >
                  + Add Phone Number
                </button>
              </div>
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <div className="contact-detail-form__icon">
                    <img src="/images/ui/mail.svg"></img>
                  </div>
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Email Address"
                    value={contactDetail.email}
                    onChange={(event) =>
                      onChangeContactDetailField(
                        event.target.value,
                        'email',
                        index
                      )
                    }
                  />
                </div>
                {contactDetail.errors && contactDetail?.errors.email && (
                  <>
                    <div className="edit-error">
                      * {contactDetail?.errors.email}
                    </div>
                  </>
                )}
                {contactDetail.allowAsValidEmailVisible && (
                  <Checkbox
                    className="edit-info"
                    isChecked={contactDetail.allowAsValidEmail}
                    onChange={(event) => onChangeContactDetailField(event.target.checked, "allowAsValidEmail", index)}
                  >
                    {ADD_THIS_EMAIL_ANYWAY}
                  </Checkbox>
                )}
              </div>
              <button
                className="business-underline-btn"
                onClick={() =>
                  onClickRemoveContactDetail(contactDetail.id as number)
                }
                disabled={Boolean(contactDetail.isPrimary)}
              >
                Remove
              </button>
              {!contactDetail.isPrimary && (
                <>
                  <span className="business-btn-seprator">|</span>
                  <button
                    className="business-underline-btn"
                    onClick={() => onClickSetPrimary(index, false)}
                  >
                    Set As Primary
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
        {addcontactDetails.map((contactDetail, index) => (
          <div className="contact-detail-item" key={index}>
            {contactDetail.isPrimary && (
              <div className="contact-detail-item__primary-header">
                Primary Contact Details
              </div>
            )}
            <div className="contact-detail-form">
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <div className="contact-detail-form__icon">
                    <img src="/images/ui/user-outline.svg"></img>
                  </div>
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Contact Name"
                    value={contactDetail.name}
                    onChange={(event) =>
                      onChangeContactField(event, index, 'name')
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__position-title"
                    type="text"
                    placeholder="Enter Contact Tittle"
                    value={contactDetail.title}
                    onChange={(event) =>
                      onChangeContactField(event, index, 'title')
                    }
                  />
                </div>
                {((contactDetail.errors && contactDetail?.errors.name) ||
                  (contactDetail.errors && contactDetail?.errors.title)) && (
                  <div className="contact-detail-form__input-error">
                    <div className="edit-error">
                      {contactDetail.errors && contactDetail?.errors.name && (
                        <>* {contactDetail?.errors.name}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {contactDetail.errors && contactDetail?.errors.title && (
                        <>* {contactDetail?.errors.title}</>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="contact-detail-form__item contact-detail-form__item-phone">
                {contactDetail.phone.map((phoneItem, phoneIndex) => (
                  <>
                    <div
                      className="contact-detail-form__item-row"
                      key={phoneIndex}
                    >
                      <div className="contact-detail-form__icon">
                        {phoneIndex === 0 && (
                          <img src="/images/ui/phone-outline.svg"></img>
                        )}
                      </div>
                      <ControlledInput
                        className="license-edit__input contact-detail-form__contact-name"
                        type="number"
                        placeholder="Enter Phone Number"
                        value={phoneItem.value}
                        onChange={(event) =>
                          onChangeContactDetailPhoneField(
                            event.target.value,
                            index,
                            phoneIndex,
                            'value',
                            true
                          )
                        }
                      />
                      <div className="contact-detail-form__select-dropdown">
                        <AriaSelectDropdown
                          onChangeDropdown={(value) =>
                            onChangeContactDetailPhoneField(
                              value as string,
                              index,
                              phoneIndex,
                              'label',
                              true
                            )
                          }
                          selectedOption={phoneItem.label}
                          options={Object.entries(phoneLabels)}
                          className="react-aria-Select react-aria-select-light"
                          variant="light"
                          placeholder="-Label-"
                        />
                      </div>
                      <div
                        className="contact-detail-form__delete-icon"
                        onClick={(event) =>
                          onClickRemovePhoneNumber(index, phoneIndex, true)
                        }
                      >
                        <img src="/images/ui/delete.svg" alt="" />
                      </div>
                    </div>
                    <div className="contact-detail-form__input-error">
                      {contactDetail.errors &&
                        contactDetail?.errors.phone &&
                        contactDetail?.errors.phone[phoneIndex] &&
                        contactDetail?.errors.phone[phoneIndex].valueError && (
                          <div className="edit-error">
                            *{' '}
                            {contactDetail?.errors.phone[phoneIndex].valueError}
                          </div>
                        )}
                      {contactDetail.errors &&
                        contactDetail?.errors.phone &&
                        contactDetail?.errors.phone[phoneIndex] &&
                        contactDetail?.errors.phone[phoneIndex].labelError && (
                          <div className="edit-error">
                            *{' '}
                            {contactDetail?.errors.phone[phoneIndex].labelError}
                          </div>
                        )}
                    </div>
                  </>
                ))}

                {/* <div className="contact-detail-form__item-row">
                  <div className="contact-detail-form__icon"></div>
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Phone Number"
                    value={''}
                    onChange={(event) => {}}
                  />
                  <div className="contact-detail-form__select-dropdown">
                    <AriaSelectDropdown
                      onChangeDropdown={() => {}}
                      selectedOption={'Work'}
                      options={Object.entries(phoneLabels)}
                      className="react-aria-Select react-aria-select-light"
                      variant="light"
                      placeholder="-Label-"
                    />
                  </div>
                  <div className="contact-detail-form__delete-icon">
                    <img src="/images/ui/delete.svg" alt="" />
                  </div>
                </div> */}
                <button
                  className="business-add-btn"
                  onClick={(event) => onClickAddPhoneNumber(index, true)}
                  disabled={contactDetail.phone.length >= 3}
                >
                  + Add Phone Number
                </button>
              </div>
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <div className="contact-detail-form__icon">
                    <img src="/images/ui/mail.svg"></img>
                  </div>
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Email Address"
                    value={contactDetail.email}
                    onChange={(event) =>
                      onChangeContactField(event, index, 'email')
                    }
                  />
                </div>
                {contactDetail.errors && contactDetail?.errors.email && (
                  <>
                    <div className="edit-error">
                      * {contactDetail?.errors.email}
                    </div>
                  </>
                )}
                {contactDetail.allowAsValidEmailVisible && (
                  <Checkbox
                    className="edit-info"
                    isChecked={contactDetail.allowAsValidEmail}
                    onChange={(event) => onChangeContactDetailField(event.target.checked, "allowAsValidEmail", index, true)}
                  >
                    {ADD_THIS_EMAIL_ANYWAY}
                  </Checkbox>
                )}
              </div>
              <button
                className="business-underline-btn"
                onClick={() => onClickRemoveContactDetailsNewField(index)}
                disabled={Boolean(contactDetail.isPrimary)}
              >
                Remove
              </button>
              {!contactDetail.isPrimary && (
                <>
                  <span className="business-btn-seprator">|</span>
                  <button
                    className="business-underline-btn"
                    onClick={() => onClickSetPrimary(index, true)}
                  >
                    Set As Primary
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
      <button
        className="business-add-btn"
        onClick={onClickAddContactDetails}
        disabled={addcontactDetails.length + contactDetails.length >= 3}
      >
        + Add Contact Detail
      </button>
    </div>
  );
}

export default ContactDetailsEdit;
